import { Button } from '@brighterion/br-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import styles from './EditOverrideBtn.css';

type Props = {
    id: string;
    showButton?: boolean;
    selectedRowId: string;
    hasOverride: boolean;
};

const EditOverrideBtn = ({ id, showButton, selectedRowId, hasOverride }: Props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();

    const editRule = () => {
        if (hasOverride) {
            history.push(`${location.pathname}/edit-merchant-override/${id}?selectedRowId=${selectedRowId}`);
        } else {
            history.push(`${location.pathname}/add-merchant-override/${id}?selectedRowId=${selectedRowId}`);
        }
    };

    return (
        <div className={styles.container}>
            {showButton && (
                <Button
                    dataTestId='add-edit-button'
                    variant='contextual-secondary'
                    onClick={handleOnClickEvent(editRule)}
                    onKeyDown={handleKeyEvent(editRule)}
                >
                    {hasOverride ? t('Edit Override') : t('Add Override')}
                </Button>
            )}
        </div>
    );
};

export default EditOverrideBtn;
